import { css, CSSResult } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground, csColorBorder, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'

export const cseStep = {
  circleBorderRadius: css`var(--cse-step-circle-border-radius, ${csBorder.radiusRounded})`,
  circleHeight: css`var(--cse-step-circle-height, ${csSpacing.spacing07})`,
  circleWidth: css`var(--cse-step-circle-width, ${csSpacing.spacing07})`,
  iconColor: css`var(--cse-step-icon-color, ${csColorText.white})`,

  rowGap: css`var(--cse-step-row-gap, ${csSpacing.spacing02})`,
  verticalColumnGap: css`var(--cse-step-vertical-column-gap, ${csSpacing.spacing05})`,

  contentGap: css`var(--cse-step-content-gap, ${csSpacing.spacing02})`,

  initialCircleBackgroundColor: css`var(--cse-step-initial-circle-background-color, ${csColorBackground.primary})`,
  initialCircleBorderColor: css`var(--cse-step-initial-circle-border-color, ${csColorBorder.light})`,
  initialColor: css`var(--cse-step-initial-color, ${csColorText.muted})`,

  activeCircleBorderColor: css`var(--cse-step-active-circle-border-color, ${csColorFunctional.info})`,
  activeColor: css`var(--cse-step-active-color, ${csColorText.body})`,

  completedCircleBackgroundColor: css`var(--cse-step-completed-circle-background-color, ${csColorFunctional.info})`,
  completedCircleBorderColor: css`var(--cse-step-completed-circle-border-color, ${csColorFunctional.info})`,
  completedColor: css`var(--cse-step-completed-color, ${csColorText.body})`
}

export const style: CSSResult = css`
  :host {
    display: contents;
  }

  /* CSE Step */
  /* -------------------- */
  .cse-step {
    align-items: flex-start;
    display: inline-flex;
    flex-direction: column;
    position: relative;
  }

  /* CSE Text */
  /* -------------------- */
  .cse-step-content {
    --cse-step-top-gap: ${cseStep.rowGap};
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: calc(100% + var(--cse-step-top-gap));
    gap: ${cseStep.contentGap};
    width: max-content;
    color: ${cseStep.initialColor};

    @media(min-width: ${SCREENS.large}) {
      left: 50%;
      transform: translateX(-50%);
    }
  }

  /* Circle */
  /* -------------------- */
  .cse-step-circle {
    --cse-icon-color: ${cseStep.iconColor};
    align-items: center;
    background-color: ${cseStep.initialCircleBackgroundColor};
    border-color: ${cseStep.initialCircleBorderColor};
    border-radius: ${cseStep.circleBorderRadius};
    border-style: solid;
    border-width: 3px;
    color: white;
    display: flex;
    height: ${cseStep.circleHeight};
    width: ${cseStep.circleWidth};
    justify-content: center;
    text-decoration: none;
  }

  /* Variants */
  /* -------------------- */
  .variant-vertical .cse-step-content {
    --cse-step-left-gap: ${cseStep.verticalColumnGap};
    top: 0;
    left: calc(100% + var(--cse-step-left-gap));
    transform: translateX(0%);
  }

  /* States */
  /* -------------------- */
  /* active */
  .state-active .cse-step-circle {
    border-color: ${cseStep.activeCircleBorderColor};
  }

  .state-active .cse-step-content {
    color: ${cseStep.activeColor};
  }

  /* completed */
  .state-completed {
    pointer-events: all;
    cursor: pointer;
  }

  .state-completed .cse-step-circle {
    background-color: ${cseStep.completedCircleBackgroundColor};
    border-color: ${cseStep.completedCircleBorderColor};
  }

  .state-completed .cse-step-content {
    color: ${cseStep.completedColor};
  }
`
